import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../shared/api/api.tokens';
import { REQUIRE_AUTH } from '../shared/interceptors/auth-context';
import { GetSalesResponse } from '../shared/interfaces';

export type ReceiptFormat = 'half-letter' | 'ticket';

@Injectable({ providedIn: 'root' })
export class SalesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  getSales(params?: {
    page?: number;
    pageSize?: number;
    fromDate?: Date;
    toDate?: Date;
    clientId?: string;
    productId?: string;
  }): Observable<GetSalesResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.set('page', params.page.toString());
    if (params?.pageSize) queryParams.set('pageSize', params.pageSize.toString());
    if (params?.fromDate) queryParams.set('fromDate', params.fromDate.toISOString());
    if (params?.toDate) queryParams.set('toDate', params.toDate.toISOString());
    if (params?.clientId) queryParams.set('clientId', params.clientId);
    if (params?.productId) queryParams.set('productId', params.productId);

    return this.http.get<GetSalesResponse>(
      `${this.baseUrl}/api/v1/sales?${queryParams.toString()}`,
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }

  /**
   * Downloads the sale receipt PDF (non-fiscal). 'half-letter' fits two per letter
   * sheet; 'ticket' is an 80 mm roll for thermal printers.
   */
  downloadReceipt(paymentId: string, format: ReceiptFormat = 'half-letter'): Observable<Blob> {
    return this.http.get(
      `${this.baseUrl}/api/v1/sales/${paymentId}/receipt?format=${format}`,
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
        responseType: 'blob',
      }
    );
  }
}

